import { KDialog } from "@kyburz/kdesign-system";
import React from "react";

interface Props {
  open: boolean;
  url: string;
  closePopup: () => void;
}

const URLModal: React.FC<Props> = ({ open, url, closePopup }: Props) => {
  return (
    <KDialog
      size="sm"
      title="Config Download URL"
      open={open}
      primaryCTAColor="danger"
      primaryCTAText="I have copied the link - close"
      primaryCTAonClick={closePopup}
    >
      <div>
        URL for downloading the config - Please copy the link, this modal will
        only show once:
      </div>
      <a href={url} target="_blank" rel="noreferrer">
        {url}
      </a>
    </KDialog>
  );
};

export default URLModal;
